<template>
  <NuxtLayout>
    <ul v-if="breadcrumbs?.length" class="placeFeature__Breadcrumbs">
      <li v-for="item in breadcrumbs">
        <nuxt-link :to="item.sef">{{ item.title }}</nuxt-link>
      </li>
    </ul>

    <h1 class="placeFeature__Title" v-text="page.title" />

    <FlarePicture
      class="placeFeature__HeaderImage"
      :src="{ 1920: { src: page.image, width: 1440, height: 670, size: 'both', crop: 'fill' }}"
      :alt="page.image"
    />

    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  const props = defineProps({
    page: {}
  });

  const breadcrumbs = computed(() => {
    if (props.page.breadcrumbs.length) {
      try {
        return props.page.breadcrumbs.slice(-2); 
      } catch(error) {
        return [];
      }
    }
    return [];
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_placeFeature.scss');
</style>